import { TIANDITU_JS_SDK_URL } from '@/utils/tiandituConfig'

/** 天地图 JS API（与 index.html 全局脚本一致；未预加载时按需动态引入） */
const TIANDITU_SDK_URL = TIANDITU_JS_SDK_URL

let loadPromise: Promise<any> | null = null

/** 动态加载天地图 SDK，返回全局 T 对象 */
export function loadTiandituSdk(): Promise<any> {
  const w = window as any
  if (w.T?.Map && w.T?.LngLat) {
    return Promise.resolve(w.T)
  }
  if (loadPromise) {
    return loadPromise
  }

  loadPromise = new Promise((resolve, reject) => {
    let settled = false
    const succeed = () => {
      if (settled) return
      if (w.T?.Map && w.T?.LngLat) {
        settled = true
        resolve(w.T)
      } else {
        settled = true
        loadPromise = null
        reject(new Error('天地图 API 加载不完整'))
      }
    }
    const fail = (message: string) => {
      if (settled) return
      settled = true
      loadPromise = null
      reject(new Error(message))
    }

    // 兼容 index.html 全局脚本（无 data 属性）与按需注入脚本
    const existing = (document.querySelector('script[data-tianditu-sdk]') ||
      document.querySelector('script[src*="api.tianditu.gov.cn"]')) as HTMLScriptElement | null
    if (existing) {
      if (w.T?.Map) {
        succeed()
        return
      }
      existing.addEventListener('load', succeed, { once: true })
      existing.addEventListener('error', () => fail('天地图 SDK 加载失败'), { once: true })
      // 脚本已执行完毕时 load 不会再触发，短轮询兜底
      let tries = 0
      const poll = window.setInterval(() => {
        tries += 1
        if (w.T?.Map && w.T?.LngLat) {
          window.clearInterval(poll)
          succeed()
        } else if (tries >= 40) {
          window.clearInterval(poll)
          fail('天地图 SDK 加载超时')
        }
      }, 50)
      return
    }

    const script = document.createElement('script')
    script.src = TIANDITU_SDK_URL
    script.type = 'text/javascript'
    script.setAttribute('data-tianditu-sdk', 'true')
    script.onload = succeed
    script.onerror = () => fail('天地图 SDK 加载失败')
    document.body.appendChild(script)
  })

  return loadPromise
}
